import { render, staticRenderFns } from "./sqSC.vue?vue&type=template&id=fb7de2be&scoped=true&"
import script from "./sqSC.vue?vue&type=script&lang=js&"
export * from "./sqSC.vue?vue&type=script&lang=js&"
import style0 from "./sqSC.vue?vue&type=style&index=0&id=fb7de2be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7de2be",
  null
  
)

export default component.exports